class HHWishlistGrid extends HTMLElement {
  constructor() {
    super()
    this.isLoggedIn = false
    this.listId = ''
    this.swat = null
    this.pending = false
    this.wishlistContainer = null
    this.tooltipTimeout = null
  }

  connectedCallback() {
    this.customer = this.getAttribute('customer') === 'true'
    this.wishlistContainer = this.querySelector('.js-wishlist-container')
    this.loadingMessage = this.querySelector('.js-loading-message')
    if (!this.customer) {
      this.loadingMessage.innerHTML = ''
      return
    }

    this.checkLoginStatus()
    this.setupEventListeners()
  }

  setupEventListeners() {
    const shareButton = this.querySelector('.js-share-list')
    if (shareButton) {
      shareButton.addEventListener('click', this.shareList.bind(this))
    }

    document.addEventListener('wishlistProductToggled', this.handleWishlistToggle.bind(this))
  }

  async fetchWishlistItems(allHandles) {
    try {
      // Normalize and de-duplicate handles
      const normalized = Array.from(
        new Set(
          (allHandles || [])
            .map((h) => (h || '').toString().split('/products/').pop())
            .map((h) => (h || '').split('?')[0].split('#')[0])
            .filter(Boolean)
        )
      )

      if (!normalized.length || !this.wishlistContainer) {
        if (this.wishlistContainer) this.wishlistContainer.innerHTML = ''
        return
      }

      // Shopify all_products lookup limit is 20 per request/template render
      const CHUNK_SIZE = 20
      this.wishlistContainer.innerHTML = ''
      let targetList = null

      for (let i = 0; i < normalized.length; i += CHUNK_SIZE) {
        const chunk = normalized.slice(i, i + CHUNK_SIZE)
        const encoded = chunk.map(encodeURIComponent).join(',') // keep commas as separators
        const url = `/pages/wishlist-endpoint?view=wishlist-product-grid&handle=${encoded}`
        const response = await fetch(url)
        const html = await response.text()
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
        const grid = parsedHTML.getElementById('wishlist-product-grid')

        if (!grid) continue

        if (!targetList) {
          // First chunk: append the whole list
          this.wishlistContainer.appendChild(grid)
          targetList = grid
        } else {
          // Subsequent chunks: append <li> items to the existing list
          const items = Array.from(grid.children)
          items.forEach((li) => targetList.appendChild(li))
        }
      }
    } catch (error) {
      console.error('Error fetching wishlist items:', error)
    }
  }

  checkLoginStatus() {
    const onSwymLoadCallback = (swat) => {
      this.swat = swat

      const onSuccess = (response) => {
        this.isLoggedIn = response?.status === 'success' ? true : false
        const { data } = response
        if (data?.length > 0) {
          this.listId = data[0].lid
          this.checkWishlistStatus()
        } else {
          this.listId = null
        }
      }

      const onError = (error) => {
        console.error("Error while fetching user lists", error)
      }

      swat.wishlist?.fetchUserLists(onSuccess, onError)
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(onSwymLoadCallback)

    this.isLoggedIn = window.routes.account_url ? true : false
    if(!this.isLoggedIn) {
      this.loadingMessage.innerHTML = ''
    }
  }

  async checkWishlistStatus() {
    const listConfig = { "lid": this.listId }

    const onSuccess = (listContents) => {
      const productHandles = listContents.map(item => item.du.split('/products/').pop())
      this.fetchWishlistItems(productHandles)
    }

    const onError = (error) => {
      console.error("Error fetching List Contents", error)
    }

    this.swat.fetchListCtx(listConfig, onSuccess, onError)
  }

  async shareList(e) {
    e.preventDefault()
    if (!this.listId || !this.swat) {
      console.error('List ID or Swat instance not available')
      return
    }

    const onSuccess = async (link, lid) => {
      console.log("Successfully Generated Link", link, lid)
      try {
        await navigator.clipboard.writeText(link)
        alert(window.langMessages['general.wishlist.link_copied'])
      } catch (error) {
        console.error('Failed to copy text: ', error)
      }
    }

    const onError = (error) => {
      console.error("Error while generating the link", error)
    }

    this.swat.generateSharedListURL(this.listId, onSuccess, onError)
  }

  handleWishlistToggle(event) {
    setTimeout(() => {
      const { product_id: productId } = event.detail
      if (!productId) return
  
      const productCard = this.querySelector(`[data-product-id="${productId}"]`)?.closest('.js-product-card')
      productCard?.remove()
    }, 200)
  }
}

if (!customElements.get('hh-wishlist-grid')) {
  customElements.define('hh-wishlist-grid', HHWishlistGrid);
}
